import { useEffect } from 'react';
import { useCartStore } from '@/stores/newCartStore';

export const useNewCart = () => {
  const { 
    items,
    isLoading,
    initialize,
    addItem,
    removeItem,
    calculateTotal,
    cleanup
  } = useCartStore();

  useEffect(() => {
    initialize();
    return () => {
      cleanup();
    };
  }, [initialize, cleanup]);

  return {
    cartItems: items,
    isLoading,
    addToCart: addItem,
    handleRemoveItem: removeItem,
    calculateTotal
  };
};